// Shared catalogue of equipment-type presets used by both the onboarding
// wizard (Step 5) and the customer Equipment page (Add equipment type).
//
// Editing this list updates BOTH places at once. Adding a new entry here
// is the recommended way to expand the curated dropdown — the wizard's
// "➕ Add custom equipment type" path remains the escape hatch for
// anything not on the list.
//
// `freq` is the recommended `collection_frequency_per_day` (readings per
// day). `requires_calibration` is the *default* — users can still toggle
// it per piece of equipment in the wizard or in the type editor.
export const EQUIPMENT_TYPE_PRESETS = [
  {
    name: "Refrigerator - Vegetables",
    parameter: "Temperature",
    unit: "°C",
    min: 2,
    max: 5,
    freq: 2,
    requires_calibration: false,
    has_operating_range: true,
    desc: "Chilled storage for fresh produce (2–5°C).",
    label_hint: "2 to 5°C",
  },
  {
    name: "Refrigerator - Meats",
    parameter: "Temperature",
    unit: "°C",
    min: 0,
    max: 4,
    freq: 2,
    requires_calibration: false,
    has_operating_range: true,
    desc: "Chilled storage for raw meats / poultry / seafood (0–4°C).",
    label_hint: "0 to 4°C",
  },
  {
    name: "Fridge - General",
    parameter: "Temperature",
    unit: "°C",
    min: 0,
    max: 5,
    freq: 2,
    requires_calibration: false,
    has_operating_range: true,
    desc: "Fridge storage at 0°C to 5°C",
    label_hint: "0 to 5°C",
  },
  {
    name: "Freezer - General",
    parameter: "Temperature",
    unit: "°C",
    min: -40,
    max: -18,
    freq: 2,
    requires_calibration: false,
    has_operating_range: true,
    desc: "Frozen storage at −18°C or below.",
    label_hint: "-18°C and below",
  },
  // Non-temp equipment — cleanliness/maintenance only. `has_operating_range: false`
  // tells the New Type form to skip parameter/min/max/frequency fields.
  {
    name: "Band Saw",
    parameter: "",
    unit: "",
    min: null,
    max: null,
    freq: 0,
    requires_calibration: false,
    has_operating_range: false,
    desc: "Meat / produce band saw — not temperature monitored. Track blade changes, tracking & tension, and sanitation under the Cleaning & Maintenance tab.",
    label_hint: "no temperature",
  },
  // Vehicles — Delivery Truck (cleanliness only) and Cold Truck (temp + cleanliness).
  // Backend `VEHICLE_TYPE_NAMES` matches these names case-insensitively so the
  // Daily Vehicle Cleanliness checklist and the CCP Data Capture flows both
  // pick them up automatically once the tenant creates the type.
  {
    name: "Delivery Truck",
    parameter: "",
    unit: "",
    min: null,
    max: null,
    freq: 0,
    requires_calibration: false,
    has_operating_range: false,
    desc: "Non-refrigerated delivery vehicle. Daily Vehicle Cleanliness checklist only — no temperature monitoring.",
    label_hint: "vehicle · cleanliness only",
  },
  {
    name: "Cold Truck",
    parameter: "Temperature",
    unit: "°C",
    min: 0,
    max: 5,
    freq: 2,
    requires_calibration: false,
    has_operating_range: true,
    desc: "Refrigerated delivery vehicle. Default operating range 0°C to 5°C — override per unit as needed. Captures BOTH daily temperature logs (CCP data capture) and daily vehicle cleanliness checks.",
    label_hint: "0 to 5°C · vehicle",
  },
];

/** Find a preset by its display name (or undefined). */
export const findPreset = (name) =>
  EQUIPMENT_TYPE_PRESETS.find((p) => p.name === name);
